import {Injectable, OnDestroy, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ParentAPIService} from "../parent.api.service";
import {TableRecordResult} from "../../model/api/table-record-result";
import {Observable} from "rxjs";
import {CrystalclearClearingBackUrl} from "../config/crystalclear-clearing-back-url";
import {TableRequest} from "../../model/api/table-request";
import {PlResidualInfo} from "../../model/clearing/pl-residual-info";
import {PLRequest} from "../../model/clearing/pl-request";

@Injectable({
  providedIn: 'root'
})
export class ClearingAllocationPlResidualService extends ParentAPIService implements OnInit, OnDestroy {


  constructor(http: HttpClient) {
    super(http);
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
  }

  public listClearingIds(request: PLRequest): Observable<TableRecordResult<PlResidualInfo>> {
    return this.post(CrystalclearClearingBackUrl.GET_CLEARING_PL_RESIDUAL_LIST, request);
  }

  public listOrderIds(request: PLRequest): Observable<TableRecordResult<PlResidualInfo>> {
    return this.post(CrystalclearClearingBackUrl.GET_CLEARING_PL_RESIDUAL_ORDER_IDS, request);
  }




}
